import React from 'react';
import { graphql, Link } from 'gatsby';
import Li from '../components/li';
import { SEO } from '../components/SEO';
import Layout from '../components/layout';
import Customization from '../components/customization';
//import CourseContent from '../components/excel-course-content';
import CourseContent from '../components/course-content';
import { getKeyFromString } from '../utils/utils.js';
import { okBaseUrl } from '../utils/config.js';
import { SignupForCourseSidebar } from '../components/signupForCourseSidebar';
import { ContactFormSidebar } from '../components/contactFormSidebar';
import Benefits from '../components/benefitsFunctions.js';
import Logo from '../images/Logo_white@2x.png';
import style from './course.module.scss';
import learningsImage from '../images/num_of_participants@1x.png';
import ServiceWidebox from '../components/ServiceWidebox';
import ctp from '../images/ctp_rgb_190px.jpg';
import mos from '../images/mos.jpg';

export default ({ location, data }) => {
  //const { location, data } = props;
  const course = data.coursesJson;
  const classTraining = data.allClassTrainingsJson.nodes[0];
  return (
    <>
      <SEO title={course.meta.title} description={course.meta.description} />
      <Layout
        location={location}
        mainTitle={course.title.fi}
        mainTitleClasses={'mt-3'}
        additionalTitle={
          course.meta.show_additional_title
            ? course.short_tagline
              ? course.short_tagline
              : 'Yrityksellesi räätälöitynä'
            : undefined
        }
        additionalTitleClassNames={'mb-4 mt-md-0 mb-md-4'}
        tagLine={course.tagline.fi}
        headerNavLinkStyle={{ color: 'white' }}
        logo={Logo}
      >
        <div className={style.coursePageContent + ' '}>
          <div className={style.trainingContent + ' ' + 'px-5'}>
            <div className="row d-flex justify-content-center pt-0 pb-4">
              <div className="col-lg-6 col-md-6 pt-5 pr-md-6">
                <ul
                  className={
                    style.coursePageContent + ' checkList ' + style.checkList
                  }
                >
                  {course.learnings.fi.map(item => (
                    <li key={getKeyFromString(item)} className="mb-4">
                      {item}
                    </li>
                  ))}
                </ul>
                {course.id === 'excelbasic' ? <Benefits /> : undefined}
                <div className="row">
                  <div className="col-sm-8 offset-sm-4 col-md-10 offset-md-2 col-lg-8 offset-lg-4">
                    <div className="image-wrapper my-6">
                      <img className="w-100" src={learningsImage} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6">
                <div
                  className={
                    style.contactUsContainer +
                    ' ' +
                    'shadow shadow-except-mobile pt-3 pt-md-5 px-sm-4 pb-3'
                  }
                >
                  {data.allClassTrainingsJson.nodes.length > 0 &&
                  classTraining.active ? (
                    <SignupForCourseSidebar
                      title="Ilmoittaudu kurssille"
                      url={`${okBaseUrl}/${data.allClassTrainingsJson.nodes[0].signup_iframe}`}
                      date={classTraining.date}
                      location={classTraining.location}
                      duration={classTraining.duration}
                      price={classTraining.price}
                    />
                  ) : (
                    <ContactFormSidebar
                      title="Ota yhteyttä tai jätä tarjouspyyntö"
                      url={`${okBaseUrl}/fi/ota-yhteytta-iframe`}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="testimonial testimonial-x pb-5 px-5">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="quote-icon"></div>
                <h2 className="quote">{course.feedback.text.fi}</h2>
                <div className="person">{course.feedback.participant.fi}</div>
              </div>
            </div>
          </div>
          {course.id === 'excelbasic' ? (
            <>
              <ServiceWidebox
                title={'Kenelle kurssi soveltuu'}
                titleClasses={'title mt-5 mb-3'}
                titleStyle={{ color: '#019999' }}
                style={{ background: 'white', color: '#212529' }}
                theme="light"
              >
                <div className="d-flex justify-content-center">
                  <ul className="check-list text-left mt-4 mb-0">
                    {[
                      'Excelin käyttöön lisää sujuvuuttta toivoville.',
                      'Excelin peruskäyttöön kertausta kaipaaville.',
                      'Excelin käyttöä aloitteleville henkilöille.',
                    ].map(item => (
                      <Li
                        customStyle={{ color: '#019999' }}
                        key={getKeyFromString(item)}
                      >
                        {item}
                      </Li>
                    ))}
                  </ul>
                </div>
              </ServiceWidebox>
              <ServiceWidebox
                title={
                  'Kertaa ja syvennä osaamistasi koulutuksen jälkeen videokurssin avulla'
                }
                titleClasses={'title mt-5 mb-3'}
                titleStyle={{ color: '#019999' }}
                style={{ background: '#f7f7f7', color: '#212529' }}
                theme="light"
              >
                <div className="d-flex justify-content-center">
                  <ul className="check-list text-left mt-4 mb-0">
                    {[
                      'Kurssin aikana teet kouluttajan ohjaamana paljon harjoitustehtäviä.',
                      'Lisäksi saat koulutuksen jälkeen linkin videokurssiin,<br/> jonka avulla voit kerrata ja syventää osaamistasi.',
                    ].map(item => (
                      <Li
                        customStyle={{ color: '#019999' }}
                        key={getKeyFromString(item)}
                      >
                        {item}
                      </Li>
                    ))}
                  </ul>
                </div>
              </ServiceWidebox>
              <ServiceWidebox
                title={'Koulutukseen sisältyy'}
                titleClasses={'title mt-5 mb-3'}
                titleStyle={{ color: '#019999' }}
                style={{ background: 'white', color: '#212529' }}
                theme="light"
              >
                <div className="d-flex justify-content-center">
                  <ul className="check-list text-left mt-4 mb-0">
                    {[
                      'Koulutusmateriaali.',
                      'Kokousaamiainen, lounas ja iltapäiväkahvi.',
                      'Koulutuksen jälkeen: kertaavia ja syventäviä tehtäviä malliratkaisuineen.',
                    ].map(item => (
                      <Li
                        customStyle={{ color: '#019999' }}
                        key={getKeyFromString(item)}
                      >
                        {item}
                      </Li>
                    ))}
                  </ul>
                </div>
              </ServiceWidebox>
            </>
          ) : (
            undefined
          )}
          {course.customization ? (
            // Only show customization if it exists
            <Customization
              headline={course.customization.headline.fi}
              description={course.customization.description.fi}
              items={course.customization.bullets.fi}
            />
          ) : (
            undefined
          )}
          <div className="trainers-related px-5 pt-0 pb-6">
            <div className="row">
              <div className="col-md-6 d-flex justify-content-center">
                <div className="content">
                  <h3 className="text-uppercase mt-6 mb-4">
                    {course.trainers.title.fi}
                  </h3>
                  <ul className="checkList">
                    {course.trainers.items.fi.map(item => (
                      <li key={getKeyFromString(item)} className="mb-2">
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="row">
                    <div className="col-6">
                      <img src={ctp} style={{ marginTop: '-10px' }} />
                      {/* <div style={{marginTop: "-26px"}}>
                        <i style={{fontSize: "12px"}}>Certified Trainer Professional</i>
                      </div> */}
                    </div>
                    <div className="col-6">
                      <img src={mos} style={{ width: '160px' }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 d-flex justify-content-center">
                <div className="content">
                  <h3 className="text-uppercase mt-6 mb-4">
                    {'Katso myös nämä kurssit tai palvelut'}
                  </h3>
                  <ul className="checkList">
                    {/* {course.related_courses.items.fi.map(item => (
                    <li key={getKeyFromString(item)} className="mb-2">
                      {item}
                    </li>
                  ))} */}
                    {data.relatedCourses.nodes.map(item => (
                      <li
                        key={getKeyFromString(item.title.fi)}
                        className="mb-2"
                      >
                        <Link to={'/' + item.fields.fullUrlPath}>
                          {item.title.fi}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <CourseContent
            headline={course.example_content.headline.fi}
            headline_2={course.example_content.headline_2.fi}
            example_content={course.example_content}
          />
        </div>
      </Layout>
    </>
  );
};

// Adapted from https://www.gatsbyjs.org/tutorial/part-seven/#creating-pages
// Note: In the query variable $slug is available because it's passed to context
// in the createPages -hook in gatsby-node.js.
// See also: https://www.gatsbyjs.org/docs/node-apis/#createPages
export const query = graphql`
  query($slug: String!, $coursetags: [String], $course_id: String!) {
    coursesJson(fields: { slug: { eq: $slug } }) {
      id
      fields {
        fullUrlPath
      }
      tags
      meta {
        show_additional_title
        title
        description
      }
      title {
        fi
      }
      short_tagline
      tagline {
        fi
      }
      learnings {
        fi
      }
      url_path
      feedback {
        text {
          fi
        }
        texts {
          fi
        }
        participant {
          fi
        }
      }
      trainers {
        items {
          fi
        }
        title {
          fi
        }
      }
      customization {
        headline {
          fi
        }
        description {
          fi
        }
        bullets {
          fi
        }
      }
      related_courses {
        items {
          fi
        }
        title {
          fi
        }
      }
      example_content {
        headline {
          fi
        }
        headline_2 {
          fi
        }
        column_1 {
          bullets {
            fi
          }
          headline {
            fi
            icon
          }
        }
        column_2 {
          bullets {
            fi
          }
          headline {
            fi
            icon
          }
        }
      }
    }
    relatedCourses: allCoursesJson(
      filter: { tags: { in: $coursetags }, fields: { slug: { ne: $slug } } }
    ) {
      nodes {
        fields {
          fullUrlPath
        }
        title {
          fi
        }
        tags
        url_path
      }
    }
    site {
      siteMetadata {
        paths {
          course_listing
        }
      }
    }
    allClassTrainingsJson(filter: { course_id: { eq: $course_id } }) {
      nodes {
        price
        signup_iframe
        date
        course_id
        location
        duration
        active
      }
    }
  }
`;
